const STORAGE_KEY = 'topJoinConfirmedRoomId';

export const setTopJoinConfirmation = (roomId) => {
  if (!roomId) {
    return;
  }

  sessionStorage.setItem(STORAGE_KEY, String(roomId));
};

export const isTopJoinConfirmed = (roomId) => {
  if (!roomId) {
    return false;
  }

  return sessionStorage.getItem(STORAGE_KEY) === String(roomId);
};

export const clearTopJoinConfirmation = (roomId = null) => {
  if (roomId && !isTopJoinConfirmed(roomId)) {
    return;
  }

  sessionStorage.removeItem(STORAGE_KEY);
};
